const comagicAddOfflineRequest = (form = { name: '', email: '', phone: '', message: '' }) => {
  const Comagic = window?.Comagic || null;
  if (!Comagic || !Comagic.addOfflineRequest) {
    return
  }

  Comagic.push(['addOfflineRequest', {
    ...form
  }]);
}
export {
  comagicAddOfflineRequest
}
